export const validateValue = (value, options, propertyToCheck) => {
  if (options.some((item) => item[propertyToCheck] === value)) {
    return value;
  } else {
    return "";
  }
};
